<template>
  <div>
    <div v-if="loading || Object.keys(Transaction).length === 0" >
      <b-card v-for="n in 4" :key="n">
        <b-skeleton width="100%" height="400px"></b-skeleton>
          
      </b-card>

    </div>
    
    <div v-else>
      <!-- معلومات المعاملة -->
      <b-card >
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
            معلومات المعاملة
          </h3>
        </div>
        <hr />
        <b-row>
          <b-col md="4" cols="12">
            <info-card
              label="معرف المعاملة"
              :value="Transaction.id"
            />
            
          </b-col>
          <b-col md="4" cols="12">
            <info-card
              label="نوع المعاملة"
              :value="Transaction.transactionType.name"
            />
          </b-col>
          <b-col md="4" cols="12">
              <b-card class="profile-header">
                <div class="info-card w-100 px-2 py-1">
                    <h6
                    style="width: fit-content; padding: 4px 6px; margin-bottom: 6px;"
                    class="bg-info rounded text-white font-weight-bold"
                    >
                    حالة المعاملة 
                    </h6>
                    <transactions-status-formatter :value="Transaction.status" />
                    <hr />
                </div>

              </b-card>
          </b-col>
          <b-col md="4" cols="12">
            <info-card label="تاريخ تقديم المعاملة" :value="formatDate(Transaction.created_at, 'YYYY-MM-DD')"  />
          </b-col>
          <b-col md="4" cols="12"  v-if='Transaction.actionHistories && Transaction.actionHistories.length > 0'>
            <info-card label="التاريخ اللازم للبدء في المعاملة" :value="Transaction.start_date" />
          </b-col>
          <b-col md="4" cols="12">
            <info-card label="التاريخ اللازم للإنتهاء من تدقيق المعاملة" :value="Transaction.end_date" />
          </b-col>
          <b-col md="4" cols="12">
            <info-card label="تاريخ أخر تعديل على المعاملة" :value="formatDate(Transaction.updated_at, 'YYYY-MM-DD')"   />
          </b-col>
        </b-row>
      </b-card>
      <!-- بيانات المعاملة -->
      <b-card v-if="Object.keys(form).length>0">
        
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
            بيانات المعاملة
          </h3>
        </div>
        <hr />
        <component :is="getComponentName(Transaction.transactionType.slug)"
          :data="form"
          :url="Transaction.transactionType.slug === 'logo_approval' ? Transaction.transactionRequestData[0].field_value : null"
        />
      </b-card>
      <!-- سير المعاملة -->
      <b-card v-if='Transaction.actionHistories && Transaction.actionHistories.length > 0'>
        
        <div class="justify-content-between align-items-center d-flex">
          <h3>
            <feather-icon size="22" icon="InfoIcon" />
            سير المعاملة
          </h3>
        </div>
        <hr />
        <show-transaction-flow :actionHistories="Transaction.actionHistories" :is-ngo="true"></show-transaction-flow>
      </b-card>

    </div>
  </div>
</template>

<script>
import {BImg , BRow, BCol, BCard, BButton , VBTooltip , VBToggle , BAvatar, BMedia, BCollapse, BListGroup, BListGroupItem, BAvatarGroup, BBadge, BSkeleton} from "bootstrap-vue";
import DataTable from "@/components/data-table";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import TransactionsStatusFormatter from "../../components/TransactionsStatusFormatter.vue";
import { formatDate } from "@/utils/utils";
import {
  ShowLogo,
  ShowMeetings,
  ShowFounder,
  ShowCampaign,
  ShowBranch,
  ShowActivityFormModal,
  ShowTransactionProvider,
  ShowTransactionFlow,
  ShowCollaboration,
  ShowFinancialGrant,
  ShowBoard,
  ShowInternalDonation,
  ShowExternalDonationModal,
  ShowMoneyTransfer,
  ShowHoldGeneralBodyMeeting,
  ShowDissolutionNGO,
  ShowInternationalEventsSubscription,
  ShowComplaintAndObjectionAgainstViolation,
  ShowUnknownBranch,
  ShowJoiningInternationalNGO,
  ShowModifyingInternalSystem,
  ShowMergingTwoNgos
} from "../../components";
import { getModifiedTransactionData } from "./utils";
export default {
  props: {
    id: Number | String,
  },
  components: {
    BRow, BCol, BCard, DataTable, MinistryBreadcrumbs, BButton, InfoCard , AppTimeline, AppTimelineItem, TransactionsStatusFormatter ,
    BImg, BAvatar, BMedia, BCollapse, BListGroup, BListGroupItem, BAvatarGroup, BBadge , BSkeleton , ShowLogo , ShowMeetings , ShowFounder , ShowCampaign , ShowBranch , ShowActivityFormModal , 
    ShowTransactionProvider,
    ShowTransactionFlow,
    ShowCollaboration,
    ShowFinancialGrant,
    ShowHoldGeneralBodyMeeting,
    ShowBoard,
    ShowInternalDonation,
    ShowExternalDonationModal,
    ShowMoneyTransfer,
    ShowDissolutionNGO,
    ShowInternationalEventsSubscription,
    ShowComplaintAndObjectionAgainstViolation,
    ShowUnknownBranch,
    ShowJoiningInternationalNGO,
    ShowModifyingInternalSystem,
    ShowMergingTwoNgos
  },
  async mounted() {
    await this.fetchTransactioById(this.$route.params.id);
    this.typeOfTransaction = this.Transaction.transactionType.slug 
    this.form = getModifiedTransactionData( this.typeOfTransaction , this.Transaction)

  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["Transaction" , "loading"]),
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["fetchTransactioById"]),
    formatDate(value , formFormat) {
      return formatDate(value, formFormat);
    },
    getComponentName(typeOfTransaction) {
      switch (typeOfTransaction) {
        case 'logo_approval':
          return 'show-logo';
        case 'minutes_of_administrative_meetings':
          return 'show-meetings';
        case 'member_of_board_of_directors_or_Trustees':
          return 'show-founder';
        case 'fundraising_campaign':
          return 'show-campaign';
        case 'open_office':
          return 'show-branch';
        case 'annual_plan_approval':
          return 'show-activity-form-modal';
        case 'collaboration_two_local_partners':
          return 'show-collaboration';
        case 'financial_grant_request':
          return 'show-financial-grant';
        case 'hold_general_body_meeting':
          return 'show-hold-general-body-meeting';
        case 'hold_general_body_meeting_2':
          return 'show-hold-general-body-meeting';
        case 'changing_the_board_of_directors_or_trustees':
          return 'show-board';
        case 'national_donations':
          return 'show-internal-donation';
        case 'international_donations':
          return 'show-external-donation-modal';
        case 'transfer_money_abroads': 
          return 'Show-money-transfer'
        case 'dissolution_of_an_NGO': 
          return 'show-dissolution-nGO'
        case 'international_events_subscriptions':
          return 'show-international-events-subscription'
        case 'un_known_branch':
          return 'show-unknown-branch'
        case 'membership_application_to_international_organization':
          return 'show-joining-international-nGO'
        case 'complaint_and_objection_against_violation':
          return 'show-complaint-and-objection-against-violation'
        case 'internal_system_modification_requests':
          return 'show-modifying-internal-system'
        case 'merging_two_ngos':
          return 'show-merging-two-ngos'
        default:
          return ''; // Define a default component if needed
      }
    },
  },
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      form:{},
      typeOfTransaction : null ,
    };
  },
};
</script>
<style lang="scss" scoped>
.advanced-report {
  position: fixed;
  bottom: 6%;
  z-index: 1031;
  right: 1%;
}
.timeline-item {
  list-style: none;
}
</style>
